/**
 * SearchAnimation
 *
 * A view that controls the full page loading animation.
 *
 * @return {view}
 */

OT.createNS('OT.Redesign.Views.SearchAnimation');

OT.Redesign.Views.SearchAnimation = Backbone.ViewManager.BaseView.extend({
    el: '#loading_animation',

    initialize: function() {
        OT.Events.on('results:get',          $.proxy(this, 'showLoader'));
        OT.Events.on('results:done',         $.proxy(this, 'hideLoader'));
        OT.Events.on('results:slow',         $.proxy(this, 'showSlowMessage'));
        OT.Events.on('results:error',        $.proxy(this, 'showConnectionErrorMessage'));
        OT.Events.on('results:changed-view', $.proxy(this, 'showLoader'));
        OT.Events.on('results:view-loaded',  $.proxy(this, 'hideLoader'));


        this.$errorContainer = this.$el.find('#loading_error_container');
    },

    showLoader: function() {
      var searchData = OT.Search.Data.get();

      if (searchData.Experiments.sv1181 &&
        (searchData.Request.Size || searchData.Request.Limit) <= 15) {
        this.toHide = '#loading-animation-row';
        $(this.toHide).show();
      } else {
        this.toHide = '#loading_animation';

        var width = $(window).width();
        this.$errorContainer.empty();
        this.$el.show().width(width);
      }
    },

    hideLoader: function() {
        $(this.toHide).hide();
    },

    showSlowMessage: function() {
        this.$errorContainer.text('Searching...').show();
    },

    showConnectionErrorMessage: function() {
        // this.$el.find('#loading_error_container').text('Connection error').show();
        // this.hideLoader();
    }
});
